import BoldedValue from 'components/BoldedValue';

const WidgetDescription = ({
  showNoDataInfoBox,
  isEmptyStateMetric,
  dataCyPrefix,
  missingGraphData,
  isPmCustomDashboard,
  graph,
  filters,
  formattedAverage,
  formattedDescription,
  percentOffValue,
  ...rest
}) => {
  if (showNoDataInfoBox || isEmptyStateMetric) {
    return null;
  }

  return (
    <BoldedValue
      value={{
        size: 'x-x-large',
        text: formattedAverage
      }}
      dataCy={`${dataCyPrefix}-graph-value`}
      description={{
        size: 'small',
        text: formattedDescription
      }}
      invisible={missingGraphData}
      isPmCustomDashboard={isPmCustomDashboard}
      {...rest}
    />
  );
};

export default WidgetDescription;
